import * as $ from 'jquery';

export type InputValue = {
  inputPrefecture: string;
};

export const AddressForm = ({ inputPrefecture }: InputValue): void => {
  const defaultPrefecture: string = $(`#${inputPrefecture}`)
    .text()
    .replace(/\s/g, '');

  if (defaultPrefecture !== '') {
    $(`#${inputPrefecture} option[value=${defaultPrefecture}]`).attr(
      'selected',
      'selected'
    );
  }
};
